import {Select} from 'antd';
import React, {SyntheticEvent, useEffect, useState} from "react";
import {SelectionMode} from '@models/index';
import userRoleFetcherHoc from "@hocs/userRoleFetcherHoc";
import {PersonRole} from "@models/person-role";


const Option = Select.Option;


export interface RoleMultiSelectionReturnValue {
  new_roles: string[];
  deleted_roles: string[];
  selectedItems: PersonRole[]
}

export const roleMultiSelectionDefaultReturnValue: RoleMultiSelectionReturnValue = {
  new_roles: [],
  deleted_roles: [],
  selectedItems: []
};

type TagSelectionProps = {
  mode: SelectionMode,
  onChange: (value: RoleMultiSelectionReturnValue) => void
  selectedTags: PersonRole[],
  data: PersonRole[],
  onScroll: (e: SyntheticEvent) => void,
  handleSearch: (query: string) => void,
  fetchData: (params: object | null) => void,
  filter?: object,
  isFetched: boolean,
  initialValue: PersonRole[] | PersonRole | null
}


/**
 * This class handle selection of roles
 * Use Select fro ant-design because it has on scroll option
 * In terms of lazy loading of data, selected items should bre rendered separated
 * On Change callback return an object from new and deleted roles
 * @param props
 * @constructor
 */
const UserRolesSelection: React.FC<TagSelectionProps> = props => {
  const {handleSearch, onScroll, data = [], initialValue, onChange, fetchData, isFetched, mode = SelectionMode.DEFAULT} = props;
  const defaultValue = mode == SelectionMode.MULTIPLE ? [] : null;
  
  const retrieveValueFromProps = () => {
    if (mode == SelectionMode.MULTIPLE) {
      const returnValue = props.initialValue || [];
      return returnValue.map(item => item.id)
    }
    else {
      return props.initialValue ? props.initialValue.id : null
    }
  };
  
  const [value, setValue] = useState(initialValue ? retrieveValueFromProps() : defaultValue);
  
  useEffect(() => {
    const value = retrieveValueFromProps();
    setValue(value);
  }, [props.initialValue]);
  
  
  /**
   * To handle show selected roles before fetch data
   */
  const getData = () => {
    if (mode == SelectionMode.MULTIPLE) {
      let returnData = data;
      const selectedValues = props.initialValue || [];
      selectedValues.forEach(role => {
        if (returnData.findIndex(opt => opt.id === role.id) === -1) {
          returnData.push(role)
        }
      });
      
      return returnData;
    }
    else {
      return initialValue && !data.find(opt => opt.id == initialValue.id) ? [...data, initialValue] : data;
    }
  };
  
  const onChangeValue = (newValue, option) => {
    setValue(newValue);
    if (mode == SelectionMode.MULTIPLE) {
      const selectedValues = props.initialValue || [];
      const oldValue = selectedValues.map(cat => cat.id);
      const deleted_roles = oldValue.filter(item => newValue.findIndex(id => id === item) === -1);
      const new_roles = newValue.filter(item => oldValue.findIndex(id => id === item) === -1);
      
      props.onChange({
        deleted_roles,
        new_roles,
        selectedItems: option.map(opt => opt.props.role)
      });
    }
    else {
      onChange(option.props.role)
    }
  };
  
  const onFocus = () => {
    if (isFetched == false) {
      fetchData({});
    }
  };
  
  return (
    <Select
      showSearch
      mode={mode}
      value={value}
      defaultActiveFirstOption={false}
      showArrow={true}
      filterOption={false}
      onChange={onChangeValue}
      onFocus={onFocus}
      onSearch={handleSearch}
      onPopupScroll={onScroll}
      notFoundContent={null}
    >
      {getData().map(role =>
        <Option key={role.id} role={role}>{role.title}</Option>
      )}
    </Select>
  );
};

export default userRoleFetcherHoc(UserRolesSelection);


